import React, { useState, useEffect } from 'react';
import axiosInstance from '../axiosInstance';

const SessionLogger = ({ user }) => {

  const todayLocal = () => {
    const d = new Date();
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().slice(0, 10);
  };


  const [students, setStudents] = useState([]);
  const [session, setSession] = useState({ studentId: '', hours: '', date: todayLocal() });
  const [status, setStatus] = useState('');

  useEffect(() => {
    axiosInstance.get('/students').then(res => {
      if (user.role === 'teacher') {
        // Teachers only see their own students
        setStudents(res.data.filter(student => student.teacher === user.name));
      } else {
        // Admins see all students
        setStudents(res.data);
      }
    });
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const hoursNum = parseFloat(session.hours);

    console.log({
      raw: new Date().toString(),
      iso: new Date().toISOString(),
      fixed: todayLocal()
    });


    if (!session.studentId) return alert("Select a student.");
    if (hoursNum <= 0 || hoursNum > 12) return alert("Hours must be 0.25–12.");
    const today = todayLocal();

    if (session.date > today) {
      return alert("Cannot log future sessions.");
    }

    setStatus('Processing...');
    try {
      await axiosInstance.post('/log-session', session);
      setStatus('✅ Session logged successfully');
      setSession({
        studentId: '',
        hours: '',
        date: todayLocal()
      });
    } catch (err) {
      setStatus('❌ Error: ' + (err.response?.data?.message || "Check your connection."));
    }
  };

  return (
    <div className="page-container">
      <h3>Log Student Session</h3>

      <form onSubmit={handleSubmit} className="vertical-form">
        <label>Student</label>
        <select
          value={session.studentId}
          onChange={e => setSession({ ...session, studentId: e.target.value })}
        >
          <option value="">Select Student...</option>
          {students.map(s => (
            <option key={s._id} value={s._id}>
              {s.name}{s.teacher ? ` (${s.teacher})` : ''}
            </option>
          ))}
        </select>

        <label>Duration (Hours)</label>
        <input
          type="number"
          step="0.25"
          value={session.hours}
          onChange={e => setSession({ ...session, hours: e.target.value })}
        />

        <label>Date</label>
        <input
          type="date"
          value={session.date}
          onChange={e =>
            setSession(s => ({ ...s, date: e.target.value }))
          }
        />

        <button type="submit" className="submit-btn">
          Post to Ledger
        </button>

        {status && <p className="status-msg">{status}</p>}
      </form>
    </div>
  );
};

export default SessionLogger;
